import { createApiSlice } from "@common";
import {
  CRUD_CONVERT_OPPORTUNITY_TO_CONTRACT,
  CRUD_CONVERT_OPPORTUNITY_TO_ORDER,
} from "@routes";

const apiConfig = [
  {
    name: "convertOpportunityToContract",
    method: "post",
    url: CRUD_CONVERT_OPPORTUNITY_TO_CONTRACT,
    stateKey: "message",
  },
  {
    name: "convertOpportunityToOrder",
    method: "post",
    url: CRUD_CONVERT_OPPORTUNITY_TO_ORDER,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    loading: false,
    message: "",
  },
  reducers: {},
  extraReducers: {},
};

const { slice, thunks } = createApiSlice(
  "opportunityConversion",
  apiConfig,
  customReducers
);

const opportunityConversionSlice = slice;

export default opportunityConversionSlice.reducer;

export const {
  convertOpportunityToContract,
  convertOpportunityToOrder,
} = thunks;

